const Link = ({ name, text, setPage, className=''}) => {
    const onClick = e => {
        e.preventDefault();
        setPage(name);
    };
    const href = `${name}.html`;

    return (
    <a className={className} href={href} onClick={onClick}>
        { text }
    </a>)
}

export default Link;